import React from 'react';
import { Box, LinearProgress, Typography, Grid } from '@mui/material';
import AdminLayoutView from 'src/Layout/AdminLayout/AdminLayoutView';
import AdminTabs from 'src/Layout/AdminLayout/AdminTabs';
import { AdminTabValue } from 'src/Layout/AdminLayout/AdminTabs/types';
import AdminViewWrapper from 'src/Layout/AdminLayout/AdminViewWrapper';
import { useReportsViewController } from '../../controllers';
import { ReportsHeader } from '../ReportsHeader/ReportsHeader';
import { ReportsSummary } from '../ReportsSummary/ReportsSummary';
import { ReportsTable } from '../ReportsTable/ReportsTable';
import { TableHeaderControls } from '../TableHeaderControls';

export const ReportsView = () => {
  const {
    messageErrorReports,
    messageErrorSummaryReports,
    isPageLoading,
    timePeriod,
    startDate,
    endDate,
    groupBy,
    sortConfig,
    searchQuery,
    handleTimePeriodChange,
    handleStartDateChange,
    handleEndDateChange,
    handleGroupByChange,
    handleSortChange,
    handleSearchChange,
    handleDownloadMessageErrorReport,
  } = useReportsViewController();

  const content = (
    <Box height="calc(100vh - 180px)">
      {isPageLoading && !messageErrorReports ? (
        <Box width="100%" mt={3}>
          <LinearProgress />
          <Typography align="center" mt={2}>
            Loading messaging issues report...
          </Typography>
        </Box>
      ) : (
        <Grid container spacing={2} height="100%">
          {/* Left side: Header + Summary statistics */}
          <Grid item xs={12} lg={3} height="100%">
            <Box height="100%" display="flex" flexDirection="column">
              <Box flexShrink={0}>
                <ReportsHeader
                  timePeriod={timePeriod}
                  startDate={startDate}
                  endDate={endDate}
                  onTimePeriodChange={handleTimePeriodChange}
                  onStartDateChange={handleStartDateChange}
                  onEndDateChange={handleEndDateChange}
                />
              </Box>
              <Box flex={1} minHeight={0}>
                <ReportsSummary messageErrorSummaryReports={messageErrorSummaryReports} />
              </Box>
            </Box>
          </Grid>

          {/* Right side: Data table */}
          <Grid item xs={12} lg={9} height="100%">
            <Box height="100%">
              <ReportsTable
                messageErrorReports={messageErrorReports}
                messageErrorSummaryReports={messageErrorSummaryReports}
                groupBy={groupBy}
                sortConfig={sortConfig}
                onSortChange={handleSortChange}
                onDownloadRow={handleDownloadMessageErrorReport}
                isLoading={isPageLoading}
                headerContent={
                  <TableHeaderControls
                    groupBy={groupBy}
                    onGroupByChange={handleGroupByChange}
                    onSearchChange={handleSearchChange}
                    searchQuery={searchQuery}
                    isLoading={isPageLoading}
                  />
                }
              />
            </Box>
          </Grid>
        </Grid>
      )}
    </Box>
  );

  return (
    <AdminViewWrapper>
      <AdminLayoutView tabs={<AdminTabs value={AdminTabValue.reports} />}>
        {content}
      </AdminLayoutView>
    </AdminViewWrapper>
  );
};
